document.addEventListener('alpine:init', () => {
  Alpine.data('countdownTimer', targetDateString => {
    return {
      targetDate: null,
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      expired: false,
      interval: null,

      /**
       * Parse the target date string
       * Supports multiple formats:
       * - ISO string: "2025-12-31T23:59:59"
       * - Date string: "December 31, 2025 23:59:59"
       * - Timestamp: "1735689599000"
       */
      parseTargetDate(dateString) {
        if (!dateString) {
          console.error('Countdown timer: No target date provided');
          return null;
        }

        // Try parsing as ISO string or date string
        const parsed = new Date(dateString);

        if (isNaN(parsed.getTime())) {
          console.error('Countdown timer: Invalid date format:', dateString);
          return null;
        }

        return parsed;
      },

      /**
       * Calculate time remaining and update display values
       */
      calculateTime() {
        if (!this.targetDate) {
          this.expired = true;
          return;
        }

        const now = new Date();
        const difference = this.targetDate - now;

        if (difference <= 0) {
          this.days = 0;
          this.hours = 0;
          this.minutes = 0;
          this.seconds = 0;
          this.expired = true;
          if (this.interval) {
            clearInterval(this.interval);
            this.interval = null;
          }
          return;
        }

        this.expired = false;
        this.days = Math.floor(difference / (1000 * 60 * 60 * 24));
        this.hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
        this.minutes = Math.floor((difference / (1000 * 60)) % 60);
        this.seconds = Math.floor((difference / 1000) % 60);
      },

      /**
       * Start the countdown timer
       */
      startTimer() {
        this.calculateTime();
        if (!this.interval) {
          this.interval = setInterval(() => {
            this.calculateTime();
          }, 1000);
        }
      },

      /**
       * Clean up interval on component destroy
       */
      destroy() {
        if (this.interval) {
          clearInterval(this.interval);
          this.interval = null;
        }
      },

      /**
       * Initialize the timer
       */
      init() {
        this.targetDate = this.parseTargetDate(targetDateString);
        if (this.targetDate) {
          this.startTimer();
        } else {
          this.expired = true;
        }
      },
    };
  });
});
